var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-No_Spend"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_Spend",
    "data-name": "No Spend",
    clipPath: "url(#clip-No_Spend)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36038",
    "data-name": "Group 36038",
    transform: "translate(-9501 -14156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36037",
    "data-name": "Group 36037",
    transform: "translate(-0.25 -0.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17441",
    "data-name": "Rectangle 17441",
    width: 10.5,
    height: 10.5,
    rx: 4,
    transform: "translate(9502 14157)",
    fill: "rgba(133,133,133,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17441_-_Outline",
    "data-name": "Rectangle 17441 - Outline",
    d: "M2.625.656A1.971,1.971,0,0,0,.656,2.625v5.25A1.971,1.971,0,0,0,2.625,9.844h5.25A1.971,1.971,0,0,0,9.844,7.875V2.625A1.971,1.971,0,0,0,7.875.656H2.625m0-.656h5.25A2.625,2.625,0,0,1,10.5,2.625v5.25A2.625,2.625,0,0,1,7.875,10.5H2.625A2.625,2.625,0,0,1,0,7.875V2.625A2.625,2.625,0,0,1,2.625,0Z",
    transform: "translate(9502 14157)",
    fill: "#757171"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NS",
    transform: "translate(9507.25 14164)",
    fill: "#757171",
    fontSize: 4,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.778,
    y: 0
  }, "NS")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoSpend);
export default __webpack_public_path__ + "static/media/Icon_NoSpend.a6ef60a09b5e8b295590b03cc033a475.svg";
export { ForwardRef as ReactComponent };